import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { TokenIcon } from "@web3icons/react";
import { copyToClipboard } from "../utils";
import { SYMBOL_MAP } from "../constants";

const TileCrypto = ({ data = {}, t }) => {
  const [copied, setCopied] = useState(false);
  const str = (v) => (typeof v === "string" ? v.trim() : "");
  const coin = str(data.coin),
    title = str(data.title),
    address = str(data.address);
  if (!coin && !title && !address) return null;
  const resolvedSymbol =
    (coin && SYMBOL_MAP[coin]) || (coin ? coin.toLowerCase() : "btc");
  const handleCopy = async (e) => {
    e.stopPropagation();
    await copyToClipboard(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {coin && (
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: t.labelBg,
                border: `1px solid ${t.labelBorder}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <TokenIcon
                symbol={resolvedSymbol}
                variant="branded"
                className="w-7 h-7"
                fallback={
                  <TokenIcon
                    symbol="btc"
                    variant="branded"
                    className="w-7 h-7"
                  />
                }
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flex: 1,
              minWidth: 0,
            }}
          >
            {coin && (
              <span
                style={{ fontSize: 15, fontWeight: 600, color: t.textPrimary }}
              >
                {coin}
              </span>
            )}
            {title && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.badgeBg,
                  border: `1px solid ${t.badgeBorder}`,
                  color: t.badgeText,
                  flexShrink: 0,
                }}
              >
                {title}
              </span>
            )}
          </div>
        </div>
        {address && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            <button
              onClick={handleCopy}
              type="button"
              aria-label="Copy address"
              style={{
                flexShrink: 0,
                padding: 6,
                borderRadius: 8,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                transition: "all 0.2s",
                color: copied ? t.successText : t.textMuted,
              }}
              onMouseEnter={(e) => {
                if (!copied) e.currentTarget.style.background = t.pillHoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {copied ? (
                <Check size={14} strokeWidth={2.5} />
              ) : (
                <Copy size={14} />
              )}
            </button>
            <p
              style={{
                fontSize: 11,
                color: t.textMuted,
                margin: 0,
                fontFamily: "monospace",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
                minWidth: 0,
              }}
              title={address}
            >
              {address}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TileCrypto;
